export const Rastreo =[
    {
      Header: "No. de Guía",
      accessor: "Guia"
    },
    {
      Header: "Estado",
      accessor: "Estado"
    },
    {
      Header: "casilla",
      accessor: "Recepcion"
    },
    {
      Header: "Tienda",
      accessor: "Tienda"
    },
    {
      Header: "Descripción",
      accessor: "Descripcion"
    },
    {
      Header: "Peso (kgs)",
      accessor: "Peso"
    },
    {
      Header: "Valor FOB (USD)",
      accessor: "Fob"
    },
    {
      Header: "Fecha Recepción MIAMI/ESPAÑA",
      accessor: "Fecha_recepcion_miami"
    },
    {
      Header: "Factura",
      accessor: "Factura"
    },
    {
      Header:"Imagenes",
      accessor:"Imagen1",
    }
    ,
    {
      Header: "Tracking",
      accessor: "Tracking"
    }
  ];

  export const RastreoInicial=
  {
     
  }